function r() {
  let t = Object.values(arguments).map((e) => typeof e == "string" ? e : typeof e != "object" || !e ? null : r(...Object.values(e))).filter((e) => e);
  return t.length > 0 ? t.join(" ") : null;
}
export {
  r as classes
};
